export function LoadingScreen({ label = 'DISCIPLINE wird vorbereitet' }: { label?: string }) {
  return (
    <div className="grid min-h-dvh place-items-center bg-canvas text-ink">
      <div className="flex flex-col items-center gap-4">
        <div className="relative size-10">
          <div className="absolute inset-0 rounded-full border-2 border-line" />
          <div className="absolute inset-0 animate-spin rounded-full border-2 border-transparent border-t-accent" />
        </div>
        <p className="text-sm font-medium text-muted">{label}</p>
      </div>
    </div>
  );
}
